// @flow

import React from 'react'
import css from './Footer.css'
import {DEFAULT_TEXTS} from '../../common/constants'

type Props = {
  company: string,
  description: string,
  phone: string,
  copyright: string,
  queueInfo: string
}
const Footer = ({company, description, phone, copyright, queueInfo}: Props) => {
  return (
    <footer className={css.component}>
      <div className={css.wrapper}>
        <h4 className={css.title}>{company ? company : DEFAULT_TEXTS.footerCompany}</h4>
        <p className={css.text}>{description ? description : DEFAULT_TEXTS.footerDescription}</p>
        <h2 className={css.phone}>{phone ? phone : DEFAULT_TEXTS.footerPhone}</h2>
        <p className={css.graytext}>{queueInfo ? queueInfo : DEFAULT_TEXTS.footerQueueInfo}</p>
        <hr className={css.line} />
        <p className={css.graytext}>{copyright ? copyright : DEFAULT_TEXTS.footerCopyright}</p>
      </div>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/common/components/Footer.js